import classNames from 'classnames';
import React from 'react';

type Phase = {
  title: string;
  completed: boolean;
  description: string;
};

type Props = {
  title: string;
  phases: Phase[];
};

type ItemProps = {
  index: number;
  phase: Phase;
  last: boolean;
};

export const RoadmapItem: React.FC<ItemProps> = ({ index, phase, last }) => {
  return (
    <div
      className={classNames('pb-2 pos-rel roadmap__item', {
        'is-even': index % 2,
        'is-completed': phase.completed,
        'is-last': last,
      })}
    >
      <h3 className='roadmap__item--title'>{phase.title}</h3>
      <p className='roadmap__item--description'>{phase.description}</p>
      <svg
        width='24'
        height='30'
        viewBox='0 0 24 30'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='pos-abs'
      >
        <path
          d='M11.7857 0L23.5714 15L11.7857 30L0 15L11.7857 0Z'
          fill={phase.completed ? '#FF2850' : '#FFF'}
        />
      </svg>
    </div>
  );
};

export const Roadmap: React.FC<Props> = ({ title, phases }) => {
  return (
    <div className='pos-rel py-md-4 py-2 roadmap'>
      <div className='container'>
        <h4 className='pos-rel mb-1 roadmap__title'>{title}</h4>
        <div></div>
        <div className='d-flex flex-column'>
          <div className='col-12 col-sm-10 mx-md-auto'>
            {phases.map((phase, index, array) => (
              <RoadmapItem
                index={index}
                key={`item-${phase.title}`}
                phase={phase}
                last={index === array.length - 1}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
